<template>
  <div id="app">
    <header class="header">
      <div class="header-inner">
        <router-link to="/" class="logo">PRIVATE<span>SHOP</span></router-link>

        <nav class="nav">
          <router-link to="/">{{ $t('nav.home') }}</router-link>
          <router-link to="/orders" v-if="isLogin">{{ $t('nav.orders') }}</router-link>
          <router-link to="/profile" v-if="isLogin">{{ $t('nav.profile') }}</router-link>
        </nav>

        <div class="header-right">
          <button class="lang-btn" @click="toggleLang">
            {{ locale === 'zh' ? 'EN' : '中文' }}
          </button>
          <router-link v-if="!isLogin" to="/login" class="login-link">
            {{ $t('nav.login') }}
          </router-link>
          <button v-else class="logout-btn" @click="logout">
            {{ $t('nav.logout') }}
          </button>
        </div>
      </div>
    </header>

    <main>
      <router-view />
    </main>

    <footer class="footer">
      <div>© {{ year }} PRIVATE SHOP</div>
      <div>{{ $t('footer.discreet') }}</div>
    </footer>
  </div>
</template>

<script>
import request from './utils/request'
export default {
  data() {
    return {
      loginStatus: false
    }
  },
  computed: {
   isLogin() {
      return this.loginStatus
    },
    locale () {
      return this.$i18n.locale
    },
    year () {
      return new Date().getFullYear()
    }
  },
  watch: {
    '$route'(to, from) {
      this.checkLogin()
    }
  },
  mounted() {
    this.checkLogin()
	this.getkefu()
  },
  methods: {
    checkLogin() {
      this.loginStatus = !!localStorage.getItem('token')
    },
	async getkefu() {
		const res = await request.get('/api/auth/getkefu', {})
	  localStorage.setItem('kefu',res.data)
	},
    toggleLang () {
      const next = this.locale === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = next
      localStorage.setItem('locale', next)
    },
    logout () {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      if (this.$route.path !== '/') this.$router.push('/')
      else this.$router.go(0)
    }
  },


}
</script>
